<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-binvoice-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-8">
              <h3 class="mb-0 view-header-buttons">
                {{ purchasesInvoice.seq_number ?? purchasesInvoice.code }}
                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="editPurchasesInvoice()"
                  v-if="purchasesInvoice.status === INVOICE_STATUS_DRAFT"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="
                    purchasesInvoice.status === INVOICE_STATUS_DRAFT &&
                    $currentUserCan($permissions.PERM_DELETE_PURCHASES_INVOICES)
                  "
                  type="danger"
                  icon
                  size="sm"
                  @click="deletePurchasesInvoice()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </base-button>

                <!-- <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="validatePurchasesInvoice()"
                  :disabled="loading"
                  v-if="
                    purchasesInvoice.items.length > 0 &&
                    purchasesInvoice.status === INVOICE_STATUS_DRAFT
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-check-bold"></i>
                    {{ $t("PURCHASES_INVOICES.VALIDATE") }}
                  </span>
                </base-button> -->

                <!-- <base-button
                  v-if="purchasesInvoice.status === INVOICE_STATUS_VALIDATED"
                  type="primary"
                  icon
                  size="sm"
                  @click="addPurchasesPayment()"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-money-coins"></i>
                    {{ $t("PURCHASES_INVOICES.ADD_PAYMENT") }}
                  </span>
                </base-button> -->

                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="viewPurchasesOrder()"
                  :disabled="loading"
                  v-if="purchasesInvoice.purchasesOrder"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-bag-17"></i>
                    {{ $t("PURCHASES_INVOICES.VIEW_ORDER") }}
                  </span>
                </base-button>

                <base-button
                  type="danger"
                  icon
                  size="sm"
                  @click="cancelPurchasesInvoice()"
                  :disabled="loading"
                  v-if="canCancelPurchasesInvoice"
                >
                  <span class="btn-inner--icon">
                    <i class="ni ni-fat-remove"></i>
                    {{ $t("PURCHASES_INVOICES.CANCEL") }}
                  </span>
                </base-button>

                <base-button
                  type="info"
                  icon
                  size="sm"
                  @click="print()"
                  :disabled="loading"
                  v-if="
                    purchasesInvoice.status !== INVOICE_STATUS_DRAFT &&
                    purchasesInvoice.status !== INVOICE_STATUS_CANCELED
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-file-pdf"></i>
                    {{ $t("COMMON.PRINT") }}
                  </span>
                </base-button>

                <base-button
                  type="success"
                  icon
                  size="sm"
                  @click="toggleMailModal()"
                  :disabled="loading"
                  v-if="
                    purchasesInvoice.status !== INVOICE_STATUS_DRAFT &&
                    purchasesInvoice.status !== INVOICE_STATUS_CANCELED
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-envelope"></i>
                    {{ $t("COMMON.SEND") }}
                  </span>
                </base-button>

                <base-button
                  type="primary"
                  icon
                  size="sm"
                  @click="openInvoicingDateModal()"
                  :disabled="loading"
                  v-if="$currentUserCan($permissions.PERM_EDIT_PURCHASES_INVOICES)"
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-calendar"></i>
                    {{ $t("INVOICES.UPDATE_INVOICING_DATE") }}
                  </span>
                </base-button>

                <base-button
                  type="info"
                  icon
                  size="sm"
                  @click="recalculatePricing()"
                  :disabled="loading"
                  v-if="
                    purchasesInvoice.status !== INVOICE_STATUS_CANCELED &&
                    $currentUserCan($permissions.PERM_EDIT_PURCHASES_INVOICES)
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-calculator"></i>
                    {{ $t("COMMON.RECALCULATE") }}
                  </span>
                </base-button>
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack()"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>

              <notification-subscription
                :objectType="'purchases-invoices'"
                :objectId="purchasesInvoice.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 justify-content-center justify-content-sm-between flex-wrap tabs-wrapper"
          >
            <tabs
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="nav-wrapper"
              tabNavClasses="nav nav-pills nav-fill"
              value="details"
            >
              <card shadow>
                <tab-pane title="global" id="1" :active="true">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GLOBAL") }}
                  </span>
                  <purchases-invoice-view-global
                    :purchasesInvoice="purchasesInvoice"
                  />
                </tab-pane>

                <tab-pane title="details" id="2" :active="false">
                  <span slot="title">
                    <i class="ni ni-bullet-list-67" />
                    {{ $t("COMMON.DETAILS") }}
                  </span>
                  <purchases-invoice-view-details
                    :purchasesInvoice="purchasesInvoice"
                    @purchasesInvoiceItemsUpdated="get"
                  />
                </tab-pane>

                <tab-pane
                  title="payments"
                  id="3"
                  :active="false"
                  v-if="
                    $currentUserCan(
                      $permissions.PERM_VIEW_ANY_PURCHASES_PAYMENTS
                    )
                  "
                >
                  <span slot="title">
                    <i class="ni ni-money-coins" />
                    {{ $t("COMMON.PAYMENTS") }}
                  </span>
                  <purchases-invoice-view-payments
                    :purchasesInvoice="purchasesInvoice"
                  />
                </tab-pane>

                <tab-pane
                  title="files"
                  id="998"
                  v-if="
                    $currentUserCan($permissions.PERM_VIEW_ANY_FILES) &&
                    purchasesInvoice.organization
                  "
                >
                  <span slot="title">
                    <i class="ni ni-folder-17" />
                    {{ $t("COMMON.FILES") }}
                  </span>
                  <list-file-component :object="purchasesInvoice" />
                </tab-pane>

                <tab-pane
                  title="logs"
                  id="999"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
                >
                  <span slot="title">
                    <i class="fa fa-file" />
                    {{ $t("COMMON.LOGS") }}
                  </span>
                  <purchases-invoice-view-logs
                    :purchasesInvoice="purchasesInvoice"
                  />
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </card>
    </div>

    <modal :show="showMailModal" modal-classes="modal-secondary" size="xl">
      <purchase-invoice-mail-modal-content
        :purchasesInvoice="purchasesInvoice"
        :get="get"
        :toggleMailModal="toggleMailModal"
      />
    </modal>

    <modal
      :show="showCancelModal"
      modal-classes="modal-secondary"
      @close="closeCancelModal"
    >
      <div class="text-center mb-4">
        <h3>{{ $t("PURCHASES_INVOICES.CANCEL_PURCHASES_INVOICE_QUESTION") }}</h3>
      </div>
      <base-input
        :label="`${$t('PURCHASES_INVOICES.CANCELLATION_REASON')} (*)`"
        :error="cancelErrors.cancellation_reason"
      >
        <textarea
          class="form-control"
          rows="4"
          v-model="cancelReason"
          :placeholder="
            $t('PURCHASES_INVOICES.CANCELLATION_REASON_PLACEHOLDER')
          "
        ></textarea>
      </base-input>
      <base-checkbox v-model="cancelSendMail" class="mb-3">
        {{ $t("PURCHASES_INVOICES.SEND_CANCELLATION_EMAIL") }}
      </base-checkbox>
      <base-input
        v-if="cancelSendMail"
        type="email"
        :label="$t('PURCHASES_INVOICES.RECIPIENT_EMAIL')"
        v-model="cancelRecipientEmail"
        :error="cancelErrors.recipient_email"
      />
      <template slot="footer">
        <base-button
          type="primary"
          class="mr-2"
          @click="confirmCancelPurchasesInvoice"
          :disabled="loading"
        >
          <i class="fas fa-spinner fa-spin" v-if="loading" />
          {{ $t("COMMON.YES") }}
        </base-button>
        <base-button type="secondary" @click="closeCancelModal">
          {{ $t("COMMON.NO") }}
        </base-button>
      </template>
    </modal>

    <modal
      :show="showInvoicingDateModal"
      modal-classes="modal-secondary"
      @close="closeInvoicingDateModal"
    >
      <div class="text-center mb-4">
        <h3>{{ $t("INVOICES.INVOICING_DATE") }}</h3>
      </div>
      <base-input :label="$t('INVOICES.INVOICING_DATE')">
        <flat-picker
          :config="{ allowInput: true, locale: $flatPickrLocale() }"
          class="form-control datepicker"
          v-model="invoicingDateInput"
        />
      </base-input>
      <template slot="footer">
        <base-button
          type="primary"
          class="mr-2"
          @click="saveInvoicingDate"
          :disabled="loading"
        >
          <i class="fas fa-spinner fa-spin" v-if="loading" />
          {{ $t("COMMON.SAVE") }}
        </base-button>
        <base-button type="secondary" @click="closeInvoicingDateModal">
          {{ $t("COMMON.CLOSE") }}
        </base-button>
      </template>
    </modal>
  </div>
</template>

<script>
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import moment from "moment";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  INVOICE_STATUS_CANCELED,
  INVOICE_STATUS_DRAFT,
  INVOICE_STATUS_VALIDATED,
} from "@/constants/invoices";
import { openPdfBlob } from "@/helpers/downloadPdf";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { TabPane, Tabs } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import PurchasesInvoiceViewGlobal from "./partials/PurchasesInvoiceViewGlobal.vue";
import PurchasesInvoiceViewDetails from "./partials/PurchasesInvoiceViewDetails.vue";
import PurchasesInvoiceViewLogs from "./partials/PurchasesInvoiceViewLogs.vue";
import defaultPurchasesInvoice from "./defaultPurchasesInvoice";
import PurchasesInvoiceViewPayments from "./partials/PurchasesInvoiceViewPayments.vue";
import PurchaseInvoiceMailModalContent from "./partials/PurchaseInvoiceMailModalContent";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    flatPicker,
    Tabs,
    TabPane,
    PurchasesInvoiceViewGlobal,
    PurchasesInvoiceViewDetails,
    PurchasesInvoiceViewLogs,
    ListFileComponent,
    NotificationSubscription,
    PurchasesInvoiceViewPayments,
    PurchaseInvoiceMailModalContent,
  },

  mixins: [requestErrorMixin],

  data() {
    return {
      loading: false,
      showMailModal: false,
      showInvoicingDateModal: false,
      invoicingDateInput: null,
      showCancelModal: false,
      cancelReason: "",
      cancelSendMail: false,
      cancelRecipientEmail: "",
      cancelErrors: {
        cancellation_reason: null,
        recipient_email: null,
      },
      purchasesInvoice: cloneDeep(defaultPurchasesInvoice),
      INVOICE_STATUS_DRAFT: INVOICE_STATUS_DRAFT,
      INVOICE_STATUS_CANCELED: INVOICE_STATUS_CANCELED,
      INVOICE_STATUS_VALIDATED: INVOICE_STATUS_VALIDATED,
    };
  },

  computed: {
    canCancelPurchasesInvoice() {
      if (
        !this.$currentUserCan(
          this.$permissions.PERM_CANCEL_PURCHASES_INVOICES
        )
      ) {
        return false;
      }
      if (
        this.purchasesInvoice.status === INVOICE_STATUS_CANCELED ||
        this.purchasesInvoice.status === INVOICE_STATUS_DRAFT
      ) {
        return false;
      }
      if (this.purchasesInvoice.status === INVOICE_STATUS_VALIDATED) {
        if (this.purchasesInvoice.total_paied != 0) {
          return false;
        }
        return true;
      }
      return false;
    },
  },

  watch: {},

  created() {
    this.get();
  },

  methods: {
    toggleMailModal() {
      this.showMailModal = !this.showMailModal;
    },

    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("purchasesInvoices/get", id);
        this.purchasesInvoice =
          this.$store.getters["purchasesInvoices/purchasesInvoice"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async editPurchasesInvoice(row) {
      this.$router.push({
        name: "Edit PurchasesInvoice",
        params: { id: this.purchasesInvoice.id },
      });
    },

    async validatePurchasesInvoice() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "purchasesInvoices/validate",
          this.purchasesInvoice.id
        );
        this.purchasesInvoice =
          this.$store.getters["purchasesInvoices/purchasesInvoice"];
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_INVOICES.PURCHASES_INVOICE_VALIDATED"),
        });
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async recalculatePricing() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "purchasesInvoices/recalculate",
          this.purchasesInvoice.id
        );
        this.purchasesInvoice =
          this.$store.getters["purchasesInvoices/purchasesInvoice"];
        this.$notify({
          type: "success",
          message: this.$t("COMMON.RECALCULATE_SUCCESS"),
        });
        await this.get();
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },

    cancelPurchasesInvoice() {
      this.cancelReason = "";
      this.cancelSendMail = false;
      this.cancelRecipientEmail =
        (this.purchasesInvoice.issuer &&
          (this.purchasesInvoice.issuer.billing_email ||
            this.purchasesInvoice.issuer.email)) ||
        "";
      this.cancelErrors.cancellation_reason = null;
      this.cancelErrors.recipient_email = null;
      this.showCancelModal = true;
    },

    closeCancelModal() {
      this.showCancelModal = false;
    },

    async confirmCancelPurchasesInvoice() {
      this.cancelErrors.cancellation_reason = null;
      this.cancelErrors.recipient_email = null;

      const reason = (this.cancelReason || "").trim();
      const recipientEmail = (this.cancelRecipientEmail || "").trim();

      if (!reason) {
        this.cancelErrors.cancellation_reason = this.$t(
          "PURCHASES_INVOICES.CANCELLATION_REASON_REQUIRED"
        );
        return;
      }
      if (this.cancelSendMail && !recipientEmail) {
        this.cancelErrors.recipient_email = this.$t(
          "PURCHASES_INVOICES.RECIPIENT_EMAIL_REQUIRED"
        );
        return;
      }

      try {
        this.loading = true;
        await this.$store.dispatch("purchasesInvoices/cancel", {
          id: this.purchasesInvoice.id,
          cancellation_reason: reason,
          send_mail: this.cancelSendMail,
          recipient_email: this.cancelSendMail ? recipientEmail : null,
        });
        this.purchasesInvoice =
          this.$store.getters["purchasesInvoices/purchasesInvoice"];
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_INVOICES.PURCHASES_INVOICE_CANCELED"),
        });
        this.showCancelModal = false;
        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async deletePurchasesInvoice() {
      const confirmation = await swal.fire({
        title: this.$t("PURCHASES_INVOICES.DELETE_THIS_PURCHASES_INVOICE"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch(
            "purchasesInvoices/destroy",
            this.purchasesInvoice.id
          );
          await this.goBack();
          this.$notify({
            type: "success",
            message: this.$t("PURCHASES_INVOICES.PURCHASES_INVOICE_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async viewPurchasesOrder() {
      this.$router.push(
        this.$objectViewRoute(this.purchasesInvoice.purchasesOrder)
      );
    },

    async addPurchasesPayment(row) {
      this.$router.push({
        name: "Add PurchasesPayment",
        query: {
          invoice_id: this.purchasesInvoice.id,
          amount: this.purchasesInvoice.total_remaining_payment.toFixed(2),
        },
      });
    },

    goBack() {
      this.$router.push({ name: "List PurchasesInvoices" });
    },
    async print() {
      swal.fire({
        title: `Chargement`,
        onBeforeOpen: () => {
          swal.showLoading();
        },
      });
      try {
        const response = await this.$store.dispatch(
          "purchasesInvoices/print",
          this.purchasesInvoice.id
        );
        openPdfBlob(response, `${this.purchasesInvoice.seq_number || this.purchasesInvoice.code}.pdf`);
        swal.close();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, something went wrong!",
        });
        this.setApiValidation(error.response.data.errors);
        swal.close();
      }
    },

    openInvoicingDateModal() {
      this.invoicingDateInput = this.purchasesInvoice.invoicing_date
        ? moment(this.purchasesInvoice.invoicing_date).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
      this.showInvoicingDateModal = true;
    },

    closeInvoicingDateModal() {
      this.showInvoicingDateModal = false;
      this.apiValidationErrors = {};
    },

    async saveInvoicingDate() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "purchasesInvoices/updateInvoicingDate",
          {
            id: this.purchasesInvoice.id,
            invoicing_date: this.$getUtcDateTimeString(
              moment(this.invoicingDateInput).hour(12).minute(0).second(0).toISOString()
            ),
          }
        );
        this.purchasesInvoice =
          this.$store.getters["purchasesInvoices/purchasesInvoice"];
        this.showInvoicingDateModal = false;
        this.$notify({
          type: "success",
          message: this.$t("COMMON.UPDATED"),
        });
        this.get();
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
